var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgICursor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 488C256 501.25 245.25 512 232 512C189.07 512 151.23 490.598 128 458.084C104.77 490.598 66.93 512 24 512C10.75 512 0 501.25 0 488S10.75 464 24 464C68.125 464 104 428.125 104 384V280H72C58.75 280 48 269.25 48 256S58.75 232 72 232H104V128C104 83.875 68.125 48 24 48C10.75 48 0 37.25 0 24S10.75 0 24 0C66.93 0 104.77 21.402 128 53.916C151.23 21.402 189.07 0 232 0C245.25 0 256 10.75 256 24S245.25 48 232 48C187.875 48 152 83.875 152 128V232H184C197.25 232 208 242.75 208 256S197.25 280 184 280H152V384C152 428.125 187.875 464 232 464C245.25 464 256 474.75 256 488Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICursor);
export default __webpack_public_path__ + "static/media/i-cursor.fb703aaef940d20eab7b1b8a7d57d0b7.svg";
export { ForwardRef as ReactComponent };